function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M479 177c-21-20-49-33-80-33h-66c-1 0-1 0-2 1s-1 3 0 4c0 1 1 1 1 1 2 2 5 4 7 7 12 12 21 26 28 41l1 1s1 1 2 1h30c15 0 29 6 39 17 11 10 17 24 17 39 0 31-25 56-56 56H282c-15 0-29-6-40-17s-17-25-17-40c0-8 2-15 5-22l1-1c0-1 0-3-1-4-1 0-1 0-2-1h-53s-1 1-2 1v1c-1 1-1 1-1 2-2 7-3 16-3 24 0 31 13 59 33 80 21 20 49 33 80 33h118c62 1 112-50 112-111 0-31-13-60-33-80zM180 360c-2-2-5-4-7-6-12-12-21-26-28-41v-1c-2-1-2-1-3-1h-30c-15-1-29-6-39-17-11-11-17-25-17-40 0-31 25-56 56-56l118 1c15 0 29 6 40 16 11 11 17 25 17 40 0 9-2 16-6 23 0 2 0 3 1 4s1 1 2 1h51c2 0 3 0 4-1v-1c1 0 1-1 1-1 2-8 3-16 3-25 0-31-13-59-33-79-21-21-49-33-80-33l-118-1C50 142 0 192 0 254c0 31 13 59 33 79 21 21 49 34 80 34h66c1 0 2-1 2-1 1-1 1-3 0-5 0 0-1 0-1-1z"
})));